import UserApi from '@/scripts/api/user.api'
import {
    serverBus
} from '@/main'
import Global from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import {
    CPUtils
} from '@/scripts/Utils'
import VueSignals from '@/scripts/VueSignals';


let oImage = null
export default {
    name: 'MyAccount',
    data() {
        return {
            showModal: false,
            firstname: SessionManager.getLoggedInUser().firstname,
            username: SessionManager.getLoggedInUser().username,
            name: SessionManager.getLoggedInUser().name,
            username_error: false,
            email: SessionManager.getLoggedInUser().email,
            image_doc: SessionManager.getLoggedInUser().image_doc,
            showExceedsSize: false,
            mainSpinner: false,
            overlayType: Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),
            username_error_message: '',
            cropping: {},
            image_size_error: false,
            isCropMove: 0,
        }

    },
    mounted() {
        this.Validate("username")


        if (this.username.length == 0) {
            Global.globalValue(VueSignals.BLOCK_USER_PROFILE_OVERLAY_CLOSE, true)
        }


        let user = SessionManager.getLoggedInUser()
        this.image_doc = user.image_doc
        this.email = user.email
        this.firstname = user.firstname
        this.name = user.name
        this.username = user.username
        oImage = user.image_db

        serverBus.$on(VueSignals.CROP_IMAGE_READY, (data) => {
            oImage = data
            if (!this.username_error) {
                UserApi.updateUser(this.username, this.name, this.firstname, oImage).then(res => {
                    if (res.data.result) {
                        this.mainSpinner = false
                        this.image_size_error = false
                        if (this.overlayType == 'update_profile') {
                            Global.globalValue(VueSignals.BLOCK_USER_PROFILE_OVERLAY_CLOSE, false)
                            this.showModal = false
                            Global.globalValue(VueSignals.SHOW_MODAL, this.showModal)
                            SessionManager.setLoggedInUser(res.data)

                            // If all good, construct the channels and redirect to home
                            Global.globalValue(VueSignals.BUS_LOGGEDIN_ARRIVED, true)
                            this.$router.push('/');
                        }
                    } else {
                        if (res.data.reason == "image_too_large") {
                            this.image_size_error = true
                        }
                    }
                })
            }
        })

        serverBus.$on(VueSignals.CROPPING_ZOOM_IN, (data) => {
            this.cropping.zoomIn()
        })
        serverBus.$on(VueSignals.CROPPING_ZOOM_OUT, (data) => {
            this.cropping.zoomOut()
        })

        document.onkeydown = function(e) {
            if (e.key == "+") {
                Global.globalValue(VueSignals.CROPPING_ZOOM_IN, true)
            }

            if (e.key == "-") {
                Global.globalValue(VueSignals.CROPPING_ZOOM_OUT, true)
            }
        }
    },
    created() {
        serverBus.$on(VueSignals.SHOW_MODAL, (modalStatus) => {
            this.showModal = modalStatus;
        });
    },
    methods: {
        updateProfile() {
            this.mainSpinner = true
            let validated = this.Validate("username")
            var reader = new FileReader()
            this.cropping.generateBlob(
                blob => {
                    // write code to upload the cropped image file (a file is a blob)
                    reader.readAsDataURL(blob)
                    reader.onloadend = function() {
                        let oImage = {
                            valueb64: reader.result.slice(reader.result.indexOf(",") + 1),
                            mimetype: reader.result.slice(4, reader.result.indexOf(";"))
                        }
                        Global.globalValue(VueSignals.CROP_IMAGE_READY, oImage)
                    }

                },
                'image/jpeg',
                1
            )
        },
        Validate(type) {
            if (type == 'username') {
                if (!CPUtils.ValidateUsername(this.username) || this.username.length == 0) {
                    this.username_error = true
                    this.username_error_message = "Please choose username, Username can't contain Special charachters like @  / \\ . $ or space"
                } else {
                    this.username_error = false
                    this.username_error_message = ''
                }
                this.mainSpinner = false
            }
        },
        handleImageRemove(e) {
            this.cropping.remove()
            this.cropping.chooseFile()
        },
        handleCroppaFileChoose() {
            this.cropping.zoomIn()
            this.cropping.moveRightwards(5)
            this.cropping.moveLeftwards(5)
        },
    }
}
